import OrderService from '../../services/OrderService';
import { PaymentHelper } from '../../helpers/PaymentHelper';
import CacheHelper from '../../helpers/CacheHelper';

const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const processFormBasedPayment = (formData) => {
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = formData.url;

  for (const [key, value] of Object.entries(formData.secrets)) {
    const encRequestInput = document.createElement('input');
    encRequestInput.type = 'hidden';
    encRequestInput.name = key;
    encRequestInput.value = value;
    form.appendChild(encRequestInput);
  }

  document.body.appendChild(form);
  form.submit();
};

const handleRazorpayPayment = async ({ resp, shop, history, setError, setShowLoading }) => {
  const secret = resp.payment_secret || resp.secret;
  PaymentHelper.setLastPaymentToLocalStorage(shop?.shopId, {
    payment_id: resp.payment_id,
    payment_secret: secret,
    shop_id: shop.shopId
  });

  const scriptLoaded = await loadRazorpayScript();
  if (!scriptLoaded) {
    setError('Razorpay SDK failed to load. Are you online?');
    setShowLoading(false);
    return;
  }

  const redirectToStatusPage = () => {
    const statusUrl = `/${shop?.shopId}/payment-status?payment_id=${resp.payment_id}&secret=${secret}`;
    if (history) {
      history.push(statusUrl);
    } else {
      window.location.href = statusUrl;
    }
  };

  const options = {
    key: resp.key_id,
    amount: resp.amount,
    currency: resp.currency,
    name: resp.name,
    description: resp.description,
    order_id: resp.tx_id,
    handler: function (response) {
      redirectToStatusPage();
    },
    modal: {
      ondismiss: function () {
        redirectToStatusPage();
      },
    },
  };

  const rzp = new window.Razorpay(options);
  rzp.on('payment.failed', function (response) {
    redirectToStatusPage();
  });

  rzp.open();
};

export const handlePayment = async ({ shop, cart, customerDetails, setShowLoading, setError, history, onOrderPlaced }) => {
  try {
    setError(null);
    setShowLoading(true);

    const customer = customerDetails || CacheHelper.getCustomerFromLocalStorage(shop?.shopId);
    CacheHelper.setCustomerToLocalStorage(shop?.shopId, customer)

    const resp = await OrderService.placeOrder(shop, cart, customer);

    if (resp && resp.payment_url) {
      window.location.href = resp.payment_url;
      return;
    } else if (resp && resp.form_data) {
      processFormBasedPayment(resp.form_data);
      PaymentHelper.setLastPaymentToLocalStorage(shop?.shopId, {
        payment_id: resp.payment_id,
        payment_secret: resp.payment_secret,
        shop_id: shop.shopId
      });
      return;
    } else if (resp && resp.key_id && resp.pg === 'razorpay') {
      await handleRazorpayPayment({ resp, shop, history, setError, setShowLoading });
      return;
    } else if (resp && resp.online_order) {
      onOrderPlaced(resp.online_order);
      return;
    } else {
      setError(resp.message || 'Failed to initiate payment');
      setShowLoading(false);
    }
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message || 'An error occurred while initiating payment';
    setError(errorMessage);
    setShowLoading(false);
  }
};

